/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-10-16 16:13:22
 */

export const handleStatusEnum = [
  { value: 0, label: '未处理' },
  { value: 1, label: '已处理' }
]
export const TYPE_LABEL = [
  { showName: '存在欺诈骗钱行为', dictionaryId: 6 },
  { showName: '发布不适当内容对我造成骚扰', dictionaryId: 7 },
  { showName: '此账号可能被盗用了', dictionaryId: 8 },
  { showName: '存在侵权行为', dictionaryId: 9 },
  { showName: '发布仿冒品信息', dictionaryId: 10 },
  { showName: '冒充他人', dictionaryId: 11 }
]
